import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "../components/ToastContainer";
import { getSageConnectErrorMessage } from "../util/sageConnectErrors";

/**
 * Handles the ?connectError=X&integration=Y query params set by OAuth callbacks
 * when a connect fails. Shows the reason as a toast and cleans the URL.
 */
function useConnectErrorFromQuery({ isLoggedIn }) {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const connectError = params.get("connectError");
    const integration = params.get("integration");

    if (!connectError || !isLoggedIn) return;

    if (integration === "sage") {
      toast.error(getSageConnectErrorMessage(connectError));
    }

    params.delete("connectError");
    params.delete("integration");
    const cleanedSearch = params.toString();
    history.replace(
      `${location.pathname}${cleanedSearch ? `?${cleanedSearch}` : ""}${location.hash || ""}`,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search, isLoggedIn]);
}

export default useConnectErrorFromQuery;
